export default {
  computed: {
    isContactDataIncorrect() {
      return !this.userData.email || !this.userData.codeword || !this.userData.password ||
        !this.userData.phone_number || !this.userData.otp; 
    }
  }
}